import {
  BookOpen,
  Building2,
  Inbox,
  LayoutDashboard,
  MapPin,
  ScrollText,
  Users,
  Wrench,
} from "lucide-react";

import { AppShell, type NavItem } from "@/client/components/app-shell";
import { useAuthStore } from "@/client/features/auth/auth-store";

const baseNav: NavItem[] = [
  { label: "Overview", to: "/admin", icon: LayoutDashboard, end: true },
  { label: "Inquiries", to: "/admin/inquiries", icon: Inbox },
  { label: "Tenants", to: "/admin/tenants", icon: Building2 },
];

// Docs and Maintenance are backed by staff-admin-only routes, so only link
// staff admins to them; plain staff would otherwise hit 403s that read like
// transient failures.
const adminNav: NavItem[] = [
  { label: "Staff", to: "/admin/users", icon: Users },
  { label: "Audit Log", to: "/admin/audit-log", icon: ScrollText },
  { label: "Docs", to: "/admin/docs", icon: BookOpen },
  { label: "Placements", to: "/admin/placements", icon: MapPin },
  { label: "Maintenance", to: "/admin/maintenance", icon: Wrench },
];

export function StaffShell() {
  const isStaffAdmin = useAuthStore((s) => s.user?.staffRole === "admin");
  const nav = isStaffAdmin ? [...baseNav, ...adminNav] : baseNav;
  return <AppShell audienceLabel="Staff" nav={nav} homeTo="/admin" />;
}
